import { useEffect, useState } from "react";
import { formatTime } from "../utils/formatTime";

export const useClock = () => {
  const [time, setTime] = useState(formatTime);

  useEffect(() => {
    const intervalId = setInterval(() => setTime(formatTime()), 1000);
    return () => clearInterval(intervalId);
  }, []);

  return time;
};
